var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIconBlue = function SvgEditIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.661 12a.658.658 0 0 1-.485-.215.65.65 0 0 1-.173-.503l.16-1.774 7.453-7.452 2.33 2.329-7.451 7.451-1.774.161a.651.651 0 0 1-.06.003zm9.75-8.08L8.081 1.59 9.479.193a.658.658 0 0 1 .931 0l1.397 1.397a.659.659 0 0 1 0 .932L10.41 3.918v.001z",
    fill: "#2355FC"
  })));
};
export default SvgEditIconBlue;